import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/AddTopic',
        name: 'AddTopic',
        component: () => import(/* webpackChunkName: "about" */ '../views/AddTopic.vue')
    },
    {
        path: '/Topic:tid',
        name: 'Topic',
        component: () => import(/* webpackChunkName: "about" */ '../views/Topic.vue'),
        props: true
    },
    {
        path: '/faq',
        name: 'faq',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/faq.vue')
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: () => import(/* webpackChunkName: "about" */ '../views/agreement.vue')
    },
    {
        path: '/policy',
        name: 'policy',
        component: () => import(/* webpackChunkName: "about" */ '../views/policy.vue')
    }, {
        path: '/changeIsp',
        name: 'changeIsp',
        component: () => import(/* webpackChunkName: "about" */ '../views/changeIsp.vue')
    }, {
        path: '/agreement_shssc',
        name: 'agreement_shssc',
        component: () => import(/* webpackChunkName: "about" */ '../views/agreement_shssc.vue')
    },
    {
        path: '/faq_shssc',
        name: 'faq_shssc',
        component: () => import(/* webpackChunkName: "about" */ '../views/faq_shssc.vue')
    }
    ,
    {
        path: '/policy_shssc',
        name: 'policy_shssc',
        component: () => import(/* webpackChunkName: "about" */ '../views/policy_shssc.vue')
    }
    ,
    {
        path: '/logout',
        name: 'logout',
        component: () => import(/* webpackChunkName: "about" */ '../views/logout.vue')
    },
    {
        path: '/logout_shssc',
        name: 'logout_shssc',
        component: () => import(/* webpackChunkName: "about" */ '../views/logout_shssc.vue')
    }
]

const router = new VueRouter({
    routes
})

export default router
